export default __webpack_public_path__ + "assets/images/Payment_02.b1d8c5.avif";